import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import myImg from "../../Assets/IMG_4040-removebg-preview.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const url = "https://api.web3forms.com/submit";
    const publicKey = "c74582d2-c70f-40a1-afb2-43c5d2bc07d2";

    const data = {
      access_key: publicKey,
      name: formData.name,
      email: formData.email,
      message: formData.message,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        alert("Your message has been sent!");
        setFormData({ name: "", email: "", message: "" });
        setShowModal(false);
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to send message.");
    }
  };

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I’ve always loved building things with code. Over time I’ve worked with
              languages like{" "}
              <b className="purple">
                Java, Python, JavaScript, C++, HTML, and PHP
              </b>
              , and I’ve gone deep into modern web stacks like{" "}
              <b className="purple">React</b>,{" "}
              <b className="purple">Next.js</b>, and{" "}
              <b className="purple">Node.js</b>.
              <br />
              <br />
              Right now, my main focus is building products especially my current
              startup,{" "}
              <a
                href="https://tracklytics.ca"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "rgb(155, 126, 172)" }}
              >
                <b className="purple">Tracklytics</b>
              </a>
              .
              <br />
              <br />
              <a
                href="https://tracklytics.ca"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "rgb(155, 126, 172)" }}
              >
                <b className="purple">Tracklytics</b>
              </a>{" "}
              is a document analytics platform
              for sales teams and founders. Instead of just sending a PDF or deck and
              guessing if someone read it,{" "}
              <a
                href="https://tracklytics.ca"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "rgb(155, 126, 172)" }}
              >
                <b className="purple">Tracklytics</b>
              </a>{" "}
              shows how people actually
              interact with what you send which pages they view, and how long they
              spend, and where they drop off, so you know who’s interested and when
              to follow up.
              <br />
              <br />
              I’m building this end-to-end, from product to data, with the goal of
              helping people close deals smarter, not louder.
              <br />
              <br />
              Outside of that, I’m always experimenting with{" "}
              <b className="purple">AI</b> and automation finding ways to reduce
              busywork, make experiences feel more personal, and ship ideas fast.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>

        {/* Social Media / Contact */}
        <Row>
          <Col md={12} className="home-about-social">
            <h1>CONNECT WITH ME</h1>
            <p>
              Feel free to{" "}
              <span className="purple">connect or reach out</span> here:
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/hsohail7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/hassansohail03/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>

            <div className="text-center mt-4">
              <Button
                variant="primary"
                onClick={() => setShowModal(true)}
                className="contact-button"
              >
                Contact Me
              </Button>
            </div>
          </Col>
        </Row>

        {/* Modal Contact Form */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Contact Me</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="formName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="mb-3"
                />
              </Form.Group>

              <Form.Group controlId="formEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="mb-3"
                />
              </Form.Group>

              <Form.Group controlId="formMessage">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Write your message here"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="mb-3"
                />
              </Form.Group>

              <Button variant="primary" type="submit" className="mt-3 w-100">
                Submit
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </Container>
    </Container>
  );
}

export default Home2;
